"use strict";

var _interopRequireDefault = require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = _interopRequireDefault(require("react"));
var _InputString = _interopRequireDefault(require("../InputString"));
var _InputPassword = _interopRequireDefault(require("../InputPassword"));
var _InputDate = _interopRequireDefault(require("../InputDate"));
var _InputNumber = _interopRequireDefault(require("../InputNumber"));
var _InputSelect = _interopRequireDefault(require("../InputSelect"));
var _InputText = _interopRequireDefault(require("../InputText"));
var _InputRelation = _interopRequireDefault(require("../InputRelation"));
var _InputImage = _interopRequireDefault(require("../InputImage"));
var _InputBooleanCheckbox = _interopRequireDefault(require("../InputBooleanCheckbox"));
var _excluded = ["type", "_type", "__type", "field", "object"];
var _jsxFileName = "/Users/mweeb/Desktop/codings/nq-component/src/InputFactory/index.js";
function InputFactory(_ref) {
  var type = _ref.type,
    _type = _ref._type,
    __type = _ref.__type,
    field = _ref.field,
    object = _ref.object,
    options = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  switch (_type || type) {
    case 'Email':
    case 'String':
      return /*#__PURE__*/_react["default"].createElement(_InputString["default"], Object.assign({
        field: field,
        type: __type || _type || type.toLowerCase(),
        object: object
      }, options, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 17,
          columnNumber: 20
        }
      }));
    case 'Password':
      return /*#__PURE__*/_react["default"].createElement(_InputPassword["default"], Object.assign({
        field: field,
        object: object
      }, options, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 23,
          columnNumber: 20
        }
      }));
    case 'Enum':
      return /*#__PURE__*/_react["default"].createElement(_InputSelect["default"], Object.assign({
        field: field,
        type: __type || _type || type.toLowerCase(),
        object: object,
        options: options.values
      }, options, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 28,
          columnNumber: 20
        }
      }));
    case 'Number':
    case 'Tel':
      return /*#__PURE__*/_react["default"].createElement(_InputNumber["default"], Object.assign({
        field: field,
        object: object
      }, options, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 36,
          columnNumber: 20
        }
      }));
    case 'Date':
      return /*#__PURE__*/_react["default"].createElement(_InputDate["default"], Object.assign({
        field: field,
        type: __type || _type || type.toLowerCase(),
        object: object
      }, options, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 41,
          columnNumber: 20
        }
      }));
    case 'Text':
      return /*#__PURE__*/_react["default"].createElement(_InputText["default"], Object.assign({
        field: field,
        type: __type || _type || type.toLowerCase(),
        object: object
      }, options, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 47,
          columnNumber: 20
        }
      }));
    case 'Relation':
    case 'Pointer':
      return /*#__PURE__*/_react["default"].createElement(_InputRelation["default"], Object.assign({
        isMulti: type === 'Relation',
        field: field,
        type: __type || _type || type.toLowerCase(),
        object: object
      }, options, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 54,
          columnNumber: 20
        }
      }));
    case 'Image':
      return /*#__PURE__*/_react["default"].createElement(_InputImage["default"], Object.assign({
        field: field,
        type: __type || _type || type.toLowerCase(),
        object: object
      }, options, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 61,
          columnNumber: 20
        }
      }));
    case 'Boolean':
      return /*#__PURE__*/_react["default"].createElement(_InputBooleanCheckbox["default"], Object.assign({
        id: field.replace(" ", ""),
        field: field,
        type: __type || _type || type.toLowerCase(),
        object: object
      }, options, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 67,
          columnNumber: 20
        }
      }));
    default:
      return null;
  }
}
var _default = InputFactory;
exports["default"] = _default;